import Sidebar from "../../components/ui/sidebar";
import { useAuth } from "../../context/AuthContext";
import { icons } from "../../assets/icons";

export default function Dashboard() {
  const { session } = useAuth();
  const userName = session?.usuario?.nombre || session?.usuario?.nombreCompleto || "";

  return (
    <div className="flex min-h-screen bg-gray-100 text-gray-900">
      <Sidebar />

      <main className="flex-1 p-4 sm:p-6 md:ml-64 transition-all flex flex-col items-center justify-center">
        <div className="text-center">
          <h2 className="text-3xl sm:text-5xl font-bold mb-8 text-gray-800">
            Bienvenido, {userName}!
          </h2>
          
          <div className="mt-4">
            <img 
              src={icons.logo} 
              alt="Logo" 
              className="max-w-xs md:max-w-md h-auto mx-auto opacity-80"
            />
          </div>
        </div>
      </main>
    </div>
  );
}

